import { Rule } from "@siteimprove/alfa-act";
import { DOM } from "@siteimprove/alfa-aria";
import { Element, Namespace, Node, Query } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Criterion } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { Scope, Stability } from "../tags/index.js";
import { WithRole } from "../common/diagnostic.js";
const { hasNonEmptyAccessibleName, hasRole, isIncludedInTheAccessibilityTree } = DOM;
const { hasNamespace } = Element;
const { and } = Predicate;
const { getElementDescendants } = Query;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r8",
    requirements: [Criterion.of("4.1.2")],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return getElementDescendants(document, Node.fullTree).filter(and(hasNamespace(Namespace.HTML), hasRole(device, "checkbox", "combobox", "listbox", "menuitemcheckbox", "menuitemradio", "radio", "searchbox", "slider", "spinbutton", "switch", "textbox"), isIncludedInTheAccessibilityTree(device)));
            },
            expectations(target) {
                const role = WithRole.getRoleName(target, device);
                return {
                    1: expectation(hasNonEmptyAccessibleName(device)(target), () => Outcomes.HasName(role), () => Outcomes.HasNoName(role)),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasName = (role) => Ok.of(WithRole.of(`The form field has an accessible name`, role));
    Outcomes.HasNoName = (role) => Err.of(WithRole.of(`The form field does not have an accessible name`, role));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map